import { useEffect, useState } from "react";
import LoadingIcon from "../../../Icon/LoadingIcon";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../../services/AxiosInstance";
import Api from "../../../../../constants/Api";
import { ApiError } from "../../../Common/ApiError";
import { convertDoubleToStringPTBR } from "../../../../../utils/ConverterUtils";

const CurrentBalanceCashFlow = (props) => {

    const { t } = useTranslation();
    const { cash } = props;
    const [closingBalance, setClosingBalance] = useState(null);
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        if (cash && cash.closingDate !== null) {
            setClosingBalance(cash.closingBalance);
        } else {
            setShowLoading(true);
            axiosInstance.get(`${Api.cash_flow.cash}/${cash.id}/current-balance`)
                .then(resp => {
                    let data = resp.data;
                    setClosingBalance(data);
                })
                .catch(error => ApiError(error))
                .finally(() => setShowLoading(false));
        }
    }, [cash]);

    return (
        <>
            {
                (showLoading) ?
                    <>
                        <div className="text-danger"><LoadingIcon /> {t('calculating')}...</div>
                    </> : 
                    <div className={
                        closingBalance > 0 ? "text-success" : closingBalance < 0 ? "text-danger" : ''
                    }>
                        {t('currency_symbol')} {convertDoubleToStringPTBR(closingBalance)}
                    </div>
            }
        </>
    )
}

export default CurrentBalanceCashFlow;